import React from "react";

export const ChrevronRight = () => (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.75 8L14.25 12.5L9.75 17" stroke="#B6B6B6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
)